import { Stack, ToggleButton, ToggleButtonGroup } from '@mui/material';
import React from 'react';

import { ReportJobNestedSectionCombineMode } from 'utils/reportJobSections';

interface Props {
  value: ReportJobNestedSectionCombineMode;
  onChange: (value: ReportJobNestedSectionCombineMode) => void;
}

const ReportJobSectionCombineModeToggle: React.FC<Props> = ({ value, onChange }) => (
  <Stack sx={{ minWidth: 0 }}>
    <ToggleButtonGroup
      size="small"
      color="primary"
      value={value}
      exclusive
      aria-label="Nested subsection combine mode"
      onChange={(_event, newValue: ReportJobNestedSectionCombineMode | null) => {
        if (!newValue) {
          return;
        }

        onChange(newValue);
      }}
    >
      <ToggleButton value="combined">Combined</ToggleButton>
      <ToggleButton value="unwound">Unwound</ToggleButton>
    </ToggleButtonGroup>
  </Stack>
);

export default ReportJobSectionCombineModeToggle;
